'use strict';

// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.set.constructor');